import { render, staticRenderFns } from "./MatchOptionsManual.vue?vue&type=template&id=775eb322&scoped=true&"
import script from "./MatchOptionsManual.vue?vue&type=script&lang=js&"
export * from "./MatchOptionsManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775eb322",
  null
  
)

export default component.exports